import request from '@/utils/request'

let iniApi = {

  saveSetting(data, errorback) {
    return request._post('/shop/plus.ini.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.ini.Setting/getSetting', data, errorback);
  },
  
}
export default iniApi;



// WEBPACK FOOTER //
// ./src/api/ini.js